import script from "./SignatureGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./SignatureGallery.vue?vue&type=script&setup=true&lang=js"

import "./SignatureGallery.vue?vue&type=style&index=0&id=25e633fa&lang=css"

const __exports__ = script;

export default __exports__